import { Injectable } from '@angular/core';
import { BaseHttpService } from '../../base/base-http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { listResponseModel, userPaySlips } from 'src/app/tabms/models/base/base';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabUserPaySlipService extends BaseHttpService<userPaySlips>{

  baseUrl = environment.baseUrlHR + this.getResourceUrl();
  constructor(private httpClinet: HttpClient) {
    super(httpClinet);
  }

  getResourceUrl(): string {
    return 'TABUserPaySlips';
  }

  //   GetPaySlipsByUser(id: any): Observable<listResponseModel<userPaySlips>> {
  //   let params = { userid: id };
  //   return this.http.get<listResponseModel<userPaySlips>>(`${this.baseUrl}/GetPaySlipsByUser`, { params: params });
  // }
  GetPaySlipsByUser(id: any): Observable<listResponseModel<userPaySlips>> {
    let params = { userid: id };
    return this.http.get<listResponseModel<userPaySlips>>(`${this.baseUrl}/GetPaySlipsByUser`, { params: params });
  }
}
